export enum Effect {
    // button
    CommonButtonClick = 'cm_button',
    CloseButtonClick = 'cm_close',

    CountdownTimerTick = 'game_count_down',
    CountdownTimerEnd = 'game_count_down_end',

    RoundPlayBetOptionWin = 'game_roundPlay_showing',
    ChipFly = 'game_roundPlay_fly',
    ChipShow = 'game_roundPlay_show',
    ChipHide = 'game_roundPlay_cancelBet',

    Scoring = 'win_scoring_loop',
    ScoringEnd = 'win_scoring_end',

    MachinePlaying = 'mainlobby_machine_playing',

    OuterLobbyVoice = 'outerlobby_enter_voice',
    LobbyVoice = 'mainlobby_enter_voice',
    ConnectMachineVoice = 'mainlobby_room_enter_voice',
}

export enum Music {
    BGM_01 = 'mainlobby_bgm',
    BGM_02 = 'mg_bgm01',
    BGM_JP = 'mainlobby_jp_bgm',
}

export enum Voice {
    StartBetting = 'vc_bet01',
    StopBetting = 'vc_bet02',
}
